import { Helmet } from "react-helmet-async";
import { POLICY_HTML } from "./policyContent";
import "./Policy.scss";

const Policy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Политика конфиденциальности</title>
        <meta
          name="description"
          content="Политика в отношении обработки персональных данных ООО «Райт Секьюрити Системс»."
        />
      </Helmet>
      <main className="policy-page">
        <div className="container">
          <article
            className="policy"
            dangerouslySetInnerHTML={{ __html: POLICY_HTML }}
          />
        </div>
      </main>
    </>
  );
};

export default Policy;
